import { fade } from '@material-ui/core/styles/colorManipulator';

export const styles = theme => ({
    tableContainer: {
        width: '99%'
    },
    frameTitle: {
        display: 'flex',
        justifyContent: 'space-between'
    },
    icon: {
        fontSize: 40,
        float: 'right',
        cursor: 'pointer'
    },
    iconWrap: {
        fontSize: 40,
        float: 'right',
        cursor: 'pointer',
        padding: '4px'
    },
});
